import * as marietta from '../..';
import { ItemControllerBasePointInput } from '.';
import { CONTROL_ACTIONMODE, SITE_INPUT_MODE } from '../Constants';

export default class ItemControllerSitePointInput extends ItemControllerBasePointInput {
  /**
     * コンストラクタ
     */
  constructor() {
    super();
    this.type = 'site';
  }

  /**
     * 形状作成の終了
     */
  endMakeShape() {
    super.endMakeShape();
    if (marietta.webcad.WebCADGlobal.webcad2Dmanager.currentSiteInputMode === SITE_INPUT_MODE.SITE_DETAILED_INPUT_MODE && marietta.webcad.WebCADGlobal.itemManager.currentItemGroup) {
      marietta.webcad.WebCADGlobal.itemManager.currentItemGroup.updateTranslate();
      const tarDialog: marietta.webcad.view.dialog.SiteBaseAndLength = marietta.webcad.WebCADGlobal.showDialog(marietta.webcad.view.dialog.SiteBaseAndLength, true, true, false, true) as marietta.webcad.view.dialog.SiteBaseAndLength;
      tarDialog.centerDialog();
    }

    // 選択モードへ変更
    // $('#btnEditSite').next('label').click();
    marietta.webcad.WebCADGlobal.webcad2Dmanager.currentActionMode = CONTROL_ACTIONMODE.ACTIONMODE_SELECT_SITE;
  }
}
